<button
  *ngIf="dayData"
  type="button"
  class="date-picker-day"
  [attr.data-size]="size"
  [attr.data-variant]="variant"
  [attr.data-current-month]="dayData.isCurrentMonth"
  [attr.data-today]="dayData.isToday"
  [attr.data-selected]="dayData.isSelected"
  [attr.data-disabled]="dayData.isDisabled || disabled"
  [attr.data-readonly]="readonly"
  [attr.data-weekend]="dayData.isWeekend"
  [attr.data-in-range]="dayData.isInRange"
  [attr.data-range-start]="dayData.isRangeStart"
  [attr.data-range-end]="dayData.isRangeEnd"
  [attr.data-hovered]="isHovered"
  [disabled]="!isClickable"
  [attr.aria-label]="ariaLabel"
  [attr.aria-selected]="dayData.isSelected"
  [attr.aria-current]="dayData.isToday ? 'date' : null"
  [attr.tabindex]="dayData.isSelected ? '0' : '-1'"
  (click)="onDayClick()"
  (mouseenter)="onDayHover()"
  (focus)="onDayFocus()"
  (keydown)="onKeyDown($event)">
  
  <span class="date-picker-day-number">
    {{ displayNumber }}
  </span>
  
  <!-- Today indicator -->
  <span 
    *ngIf="dayData.isToday && !dayData.isSelected" 
    class="date-picker-day-today-indicator"
    aria-hidden="true">
  </span>
  
  <!-- Selection indicator -->
  <span 
    *ngIf="dayData.isSelected" 
    class="date-picker-day-selection-indicator"
    aria-hidden="true">
  </span>
  
</button>
